import React from 'react';
import {
  Text, OrderedList, UnorderedList, ListItem, Alert, AlertIcon, Table, Thead, Tbody, Tr, Th, Td,
  Badge,
} from '@chakra-ui/react';

const tiManual = [
  {
    title: '1. Gerenciamento de Usuários Admin',
    content: (
      <>
        <Text mb={3}>
          Acesse via menu lateral: <strong>Usuários Admin → Lista de Usuários</strong>. Esta página permite gerenciar as contas dos usuários do painel administrativo (WebUsers).
        </Text>
        <Text mb={2}>A tabela mostra:</Text>
        <UnorderedList ml={6} spacing={1} mb={3}>
          <ListItem><strong>Nome</strong> do usuário admin</ListItem>
          <ListItem><strong>Email</strong> de acesso</ListItem>
          <ListItem><strong>Permissões</strong> — badges coloridos por perfil de acesso</ListItem>
          <ListItem><strong>Ações</strong> — editar, redefinir senha, excluir</ListItem>
        </UnorderedList>
      </>
    ),
    keywords: 'usuários admin lista webusers gerenciar painel',
  },
  {
    title: '2. Criando um Novo Usuário Admin',
    content: (
      <>
        <OrderedList spacing={2} mb={3}>
          <ListItem>Clique no botão <strong>"Novo Usuário"</strong> no topo da página</ListItem>
          <ListItem>Preencha os campos obrigatórios:</ListItem>
        </OrderedList>
        <Table size="sm" mb={3} variant="simple">
          <Thead><Tr><Th>Campo</Th><Th>Descrição</Th></Tr></Thead>
          <Tbody>
            <Tr><Td fontWeight="medium">Nome</Td><Td>Nome do usuário</Td></Tr>
            <Tr><Td fontWeight="medium">Email</Td><Td>Email para login (deve ser único)</Td></Tr>
            <Tr><Td fontWeight="medium">Senha</Td><Td>Senha de acesso (mín. 6 caracteres)</Td></Tr>
            <Tr><Td fontWeight="medium">Permissão</Td><Td>Perfil de acesso (dropdown)</Td></Tr>
          </Tbody>
        </Table>
        <OrderedList start={3} spacing={1} mb={3}>
          <ListItem>Selecione a <strong>permissão</strong> adequada no dropdown</ListItem>
          <ListItem>Clique em <strong>"Criar"</strong> para salvar</ListItem>
        </OrderedList>

        <Text fontWeight="semibold" mb={2}>Perfis de acesso disponíveis:</Text>
        <Table size="sm" mb={3} variant="simple">
          <Thead><Tr><Th>Perfil</Th><Th>Acesso</Th></Tr></Thead>
          <Tbody>
            <Tr><Td><Badge colorScheme="red">Master</Badge></Td><Td>Acesso total a todas as funcionalidades</Td></Tr>
            <Tr><Td><Badge colorScheme="purple">Administração</Badge></Td><Td>Finanças (todos os módulos)</Td></Tr>
            <Tr><Td><Badge colorScheme="blue">Suporte</Badge></Td><Td>Contratados, Contratantes, tickets de suporte</Td></Tr>
            <Tr><Td><Badge colorScheme="green">Financeiro</Badge></Td><Td>Finanças (todos os módulos)</Td></Tr>
            <Tr><Td><Badge colorScheme="orange">Comercial</Badge></Td><Td>Dashboard</Td></Tr>
            <Tr><Td><Badge colorScheme="pink">Marketing</Badge></Td><Td>Config. Mobile App (categorias, subcategorias, cores)</Td></Tr>
            <Tr><Td><Badge colorScheme="cyan">Design</Badge></Td><Td>Config. Mobile App (categorias, subcategorias, cores)</Td></Tr>
            <Tr><Td><Badge colorScheme="teal">TI</Badge></Td><Td>Usuários Admin</Td></Tr>
          </Tbody>
        </Table>
        <Alert status="warning" borderRadius="md" fontSize="sm">
          <AlertIcon />
          Apenas usuários com perfil <strong>Master</strong> ou <strong>TI</strong> podem criar e gerenciar usuários admin.
        </Alert>
      </>
    ),
    keywords: 'criar novo usuário admin permissão perfil master suporte financeiro comercial marketing design ti',
  },
  {
    title: '3. Editando e Excluindo Usuários',
    content: (
      <>
        <Text fontWeight="semibold" mb={2}>Editar:</Text>
        <OrderedList spacing={1} mb={3}>
          <ListItem>Clique no ícone de <strong>lápis</strong> na linha do usuário</ListItem>
          <ListItem>Modifique nome, email ou permissão</ListItem>
          <ListItem>Clique em <strong>"Salvar"</strong></ListItem>
        </OrderedList>
        <Text fontWeight="semibold" mb={2}>Redefinir senha:</Text>
        <OrderedList spacing={1} mb={3}>
          <ListItem>Clique no ícone de <strong>cadeado</strong></ListItem>
          <ListItem>Defina a nova senha no modal</ListItem>
          <ListItem>Confirme a alteração</ListItem>
        </OrderedList>
        <Text fontWeight="semibold" mb={2}>Excluir:</Text>
        <OrderedList spacing={1} mb={3}>
          <ListItem>Clique no ícone de <strong>lixeira</strong></ListItem>
          <ListItem>Confirme no diálogo de exclusão</ListItem>
        </OrderedList>
        <Alert status="warning" borderRadius="md" fontSize="sm">
          <AlertIcon />
          A exclusão de um usuário admin é <strong>permanente</strong> e não pode ser desfeita.
        </Alert>
      </>
    ),
    keywords: 'editar excluir redefinir senha usuário admin lápis lixeira cadeado',
  },
];

export default tiManual;
